import { CharacterMapping } from "../character/charactermapping";
import { toDict } from "./profession";
/**
 * sets the profession costs of a group
 * @param groups
 * @param profession
 * @returns
 */
export const calculateGroupProfessionCosts = (profession) => {
    let bb = toDict(profession.bb);
    let ff = toDict(profession.ff);
    return (group) => {
        const costs = bb.get(group.attribute.id);
        return Object.assign(Object.assign({}, group), { professionBonus: costs != undefined && costs.length > 0 ? costs[0] : 0, costs: ff.get(group.attribute.id) });
    };
};
export const setCharacterBonus = (groups, ca) => {
    let characterMapping = new CharacterMapping();
    return groups
        .map(a => {
        return Object.assign(Object.assign({}, a), { characterBonus: characterMapping.sumCharacterAtributes(a.attribute.id, ca), editDisabled: false });
    });
};
export const initAttribute = (attribute) => {
    return Object.assign(Object.assign({}, attribute), { level: 0, object: 0, special: 0 });
};
export const initGroup = (group) => {
    return Object.assign(Object.assign({}, group), { attribute: initAttribute(group.attribute), attributes: group.attributes.map(initAttribute) });
};
export function calculateGroups(groups, profession) {
    const professionFn = calculateGroupProfessionCosts(profession);
    return groups
        .map(professionFn)
        .map(calculateLevelBonus)
        .map(homebrewRuleInterceptor);
}
export function initGroups(groups, character, profession) {
    const updatedGroups = setCharacterBonus(groups, character).map(initGroup);
    return calculateGroups(updatedGroups, profession);
}
/**
 *
 * 1) ID 24 Tech./Gewerbe-Ber. und ID 25 Tech./Gewerbe-Prof sollten bei jedem Beruf die Kosten 3/7 haben.
 * @param group
 * @returns
 */
function homebrewRuleInterceptor(group) {
    const containsId = (ids) => ids.includes(group.attribute.id);
    if (containsId(["24", "25"])) {
        group.costs = [3, 7];
    }
    /*
    levelup regel mit speziellen progressionen
    |     | ID | Name| Beschreibung | Progression |
    |-----|----|-----|--------------|--------|
    | [x] | 5  | Handwerk (Kombiniert)            | Gruppe nicht skillbar, dafür jede Fertigkeit in der Gruppe            |`[-30, 5, 3, 1.5, 0.5]`|
    | [x] | 6  | Kampfmanöver (Kombiniert)        | Gruppe nicht skillbar, dafür jede Fertigkeit in der Gruppe            |`[-30, 5, 3, 1.5, 0.5]`|
    | [x] | 10 | Hinterhalt (Limitiert)           | (Gruppe nicht skillbar) Hinterhalt hat Progression                    |`[0.1, 1, 0.5, 0]`|
    | [x] | 24 | Tech./Gewerbe-Ber. (Kombiniert)  | Gruppe nicht skillbar, dafür jede Fertigkeit in der Gruppe            |`[-30, 5, 3, 1.5, 0.5]`|
    | [x] | 25 | Tech./Gewerbe-Prof.(Kombiniert)  | Gruppe nicht skillbar, dafür jede Fertigkeit in der Gruppe            |`[-30, 5, 3, 1.5, 0.5]`|

    */
    // gruppe kann ncicht editiert werden
    if (containsId(["5", "6", "24", "25", "10"])) {
        const progression = group.attribute.id == "10"
            ? [0, 1, 0.5]
            : [-30, 5, 3, 1.5, 0.5];
        group.editDisabled = true;
        const total = group.professionBonus + group.characterBonus + group.attribute.object + group.attribute.special;
        group.attributes = group.attributes
            .map(attr => {
            const lvl = calcLevel(attr.level, progression);
            attr.total = total + lvl;
            return attr;
        });
    }
    return group;
}
export function homebrewProgression(group, id, progression) {
    if (group.attribute.id == id) {
        const levelBonus = calcLevel(group.attribute.level, progression);
        const total = levelBonus
            + group.professionBonus
            + group.characterBonus
            + group.attribute.object
            + group.attribute.special;
        group.attribute.total = total;
    }
    return group;
}
export function calculateLevelBonus(group) {
    const progressionGroup = [-15, 2, 1, 0.5];
    const progressionAttribute = [-15, 3, 2, 1, 0.5];
    const levelBonus = calcLevel(group.attribute.level, progressionGroup);
    const total = levelBonus
        + group.professionBonus
        + group.characterBonus
        + group.attribute.object
        + group.attribute.special;
    group.attributes = group.attributes.map(attr => {
        attr.total = calcLevel(attr.level, progressionAttribute) + total + attr.object + attr.special;
        return attr;
    });
    group.attribute.total = total;
    return group;
}
/**
 *
 * | level    | fert   | grp  |
 * |----------|--------|------|
 * | 0        | -15    | -15  |
 * | 1-10     | 3      | 2    |
 * | 11-20    | 2      | 1    |
 * | 21-30    | 1      | 0.5  |
 * | 31-40    | 0.5    | 0    |
 * | 41 < x   | 0      | 0    |
 *
 * @param level
 * @param factor
 * @returns
 */
export function calcLevel(level, progression) {
    let factors = [...progression];
    if (level == 0) {
        return factors[0];
    }
    factors = factors.splice(1).reverse();
    const interval = 10;
    const levelFn = (i, lvl) => {
        if (i < 0) {
            return 0;
        }
        if (lvl > interval) {
            return levelFn(i - 1, lvl - interval) + (interval * factors[i]);
        }
        return lvl * factors[i];
    };
    return levelFn(factors.length - 1, level);
}
